import getDetailsPageUrl, {
  getDetailsPageHotelRootUrl,
} from '@stencil/hotels-utils/src/get-details-page-url';

export const createDetailsPageUrl = ({
  hotel,
  checkinJSDate,
  checkoutJSDate,
  roomString,
  countryCode,
  cityName,
  partner,
  metaPartner = '',
}) => {
  const {id = '', type = ''} = hotel?.locationDetail || {};
  const detailMakingOptions = {
    hotelData: {
      hn: hotel.name,
      hc: hotel.giId,
      // ibp: hotel.ibp,
      // hmd: hotel.hmd,
    },
    partner: partner,
    checkin: {
      date: checkinJSDate,
    },
    checkout: {
      date: checkoutJSDate,
    },
    roomString: roomString,
    cityMetaInfo: {
      coc: countryCode,
    },
    destination: {
      n: cityName,
    },
    metaPartner,
    locus: {type, id},
  };

  const detailsUrlForSimilarHotel = getDetailsPageUrl(detailMakingOptions);
  const detailsPageHotelsOnly = getDetailsPageHotelRootUrl(detailMakingOptions);
  return {detailsUrlForSimilarHotel, detailsPageHotelsOnly};
};
